module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_points3DList.7d9376d3.bin";